import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, readContacts, exportDeleteEndpoints } from '../../services';

import PbxContext from '../../context/PbxContext';
import '../../libs/bulma.min.css';
import './ContactsList.css';

import Loading from '../../components/Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faEye, faPlus, faFilter, faTrash, faSync } from '@fortawesome/free-solid-svg-icons';

function ContactsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [contacts, setContacts] = useState(() => []);
  const [contactsSelected, setContactsSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [filterText, setFilterText] = useState('');

  const history = useHistory();

  const fetchContacts = async () => {
    const getContactList = await readContacts();
    // addr: "Rio de Janeiro 123"
    // alias: "Interface"
    // cnpj: "11222333000199"
    // comm: "Empresa de suporte técnico"
    // compname: "JFNN"
    // id: 1
    // mail: "interfacedesk@teste.com"
    // namefantasy: "Interfacedesk"
    // updated: "2023-05-09T19:18:32.492Z"
    //

    if(getContactList === undefined) setLoading(true);
    setContacts(getContactList);
    setLoading(false);

    return true;
  };


  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');

    const contactsFetched = await fetchContacts();
    return contactsFetched;
  }, []);

  const filteredContacts = contacts.filter((contact) => {
    const searchText = filterText.toLowerCase();
    return (
      (contact.compname && contact.compname.toLowerCase().includes(searchText)) ||
      (contact.namefantasy && contact.namefantasy.toLowerCase().includes(searchText)) ||
      (contact.cnpj && contact.cnpj.toLowerCase().includes(searchText)) ||
      (contact.mail && contact.mail.toLowerCase().includes(searchText)) ||
      (contact.alias && contact.alias.toLowerCase().includes(searchText))
    );
  });

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="contacts-list-container">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="contacts-header">
            <div className="contacts-title-wrapper">
              <svg className="contacts-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <h1 className="contacts-title">Agenda de Contatos</h1>
                <p className="contacts-subtitle">Gerencie seus contatos e telefones</p>
              </div>
            </div>
            <button className="btn-new-contact" onClick={() => history.push('/agenda/novo')}>
              <FontAwesomeIcon icon={faPlus} />
              Novo Contato
            </button>
          </div>
          <div className="alerts-section">
            <div id="alert-endpoints-not-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-endpoints-not-delete')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível deletar os contatos selecionados.
              </div>
            </div>

            <div id="alert-confirm-endpoints-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-confirm-endpoints-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar os contatos selecionados?
              </div>
              <div className="alert-actions">
                <button className="btn-alert btn-danger" onClick={() => handleClickDelete()}>
                  <FontAwesomeIcon icon={faTrash} />
                  Confirmar
                </button>
                <button className="btn-alert btn-info" onClick={() => {
                  toggleIsHidden('#alert-confirm-endpoints-delete');
                  toggleIsHidden('#buttons');
                }}>
                  Cancelar
                </button>
              </div>
            </div>

            <div id="alert-create-endpoints" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Contatos deletados com sucesso!
              </div>
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar por razão social, nome fantasia, CNPJ, e-mail ou apelido..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredContacts.length} de {contacts.length} contato(s)
            </div>
          </div>
          
          <div className="contacts-table-wrapper">
            <table className="contacts-table">  
              <thead className="contacts-table-header">
                <tr>
                  <th>Razão Social</th>
                  <th>Nome Fantasia</th>
                  <th>CNPJ/CPF</th>
                  <th>E-mail</th>
                  <th>Apelido</th>
                  <th className="th-actions">Ações</th>
                </tr>
              </thead>
              <tbody>
              {
                filteredContacts.map((contact) => {
                  const { id, compname, namefantasy, cnpj, mail, alias } = contact;
                  return (
                    <tr key={ id }>
                      <td>{compname}</td>
                      <td>{namefantasy}</td>
                      <td>{cnpj}</td>
                      <td>{mail}</td>
                      <td>{alias}</td>
                      <td className="td-actions">
                        <button
                          className="action-btn btn-edit" type="submit"
                          onClick={() => {
                            setItemsSelectedToEdit([id]);
                            history.push('/agenda/contato/id');
                          }}
                        >
                          <span className="icon">
                            <FontAwesomeIcon icon={ faPen } fixedWidth />
                          </span>
                        </button>
                        <button
                          className="action-btn btn-view" type="submit"
                          onClick={() => {
                            setItemsSelectedToEdit([id]);
                            history.push('/agenda/contato/visualizar');
                          }}
                        >
                          <span className="icon">
                            <FontAwesomeIcon icon={ faEye } fixedWidth />
                          </span>
                        </button>
                      </td>
                    </tr>)
                })
              }
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default ContactsList;
